import { createOperation } from "features/utils";

export const fetchOperation = createOperation("ENTITIES/FETCH");
export const createEntityOperation = createOperation("ENTITIES/CREATE");
